import { useParams, Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageWrapper = () => {
    const { lang } = useParams();
    const { i18n } = useTranslation();

    useEffect(() => {
        const supportedLanguages = ["en", "fa"];

        // Default to English if unsupported language in URL
        if (!supportedLanguages.includes(lang)) {
            i18n.changeLanguage("en");
            return;
        }

        i18n.changeLanguage(lang);

        // Set RTL/LTR and document language
        const isFa = lang === "fa";
        document.documentElement.dir = isFa ? "rtl" : "ltr";
        document.documentElement.lang = isFa ? "fa" : "en";
    }, [lang, i18n]);

    // This is crucial: nested <Route> renders go here
    return <Outlet />;
};

export default LanguageWrapper;